function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import React from 'react';
import styled from '../styled-components';
import '@reach/dialog/styles.css';
import { Space, Placement } from '@webnuts/shared-components';
import { DangerButton, SecondaryButton } from '..';
import Dialog from './Dialog';
var Header =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "ConfirmationDialog__Header",
  componentId: "sc-948yje-0"
})(["font-family:'Lato',sans-serif;font-size:18px;"]);
var Description =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "ConfirmationDialog__Description",
  componentId: "sc-948yje-1"
})(["font-family:'Lato',sans-serif;font-size:14px;"]);

var ConfirmationDialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConfirmationDialog, _React$Component);

  function ConfirmationDialog() {
    _classCallCheck(this, ConfirmationDialog);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConfirmationDialog).apply(this, arguments));
  }

  _createClass(ConfirmationDialog, [{
    key: "render",
    value: function render() {
      var _this = this;

      var ConfirmButtonComponent = this.props.confirmButtonComponent || DangerButton;
      return React.createElement(Dialog, {
        initialOpen: this.props.initialOpen,
        onDismiss: this.props.onDismiss,
        content: function content(dismiss) {
          return React.createElement(React.Fragment, null, React.createElement(Space, {
            marginBottom: 32
          }, React.createElement(Header, null, React.createElement(Placement, {
            horizontal: "center",
            vertical: "center"
          }, React.createElement("span", null, _this.props.headerText))), React.createElement(Placement, {
            horizontal: "center"
          }, React.createElement(Description, null, _this.props.descriptionText))), React.createElement(Placement, {
            horizontal: "center"
          }, React.createElement(Space, {
            marginLeft: 8,
            marginRight: 8
          }, React.createElement(SecondaryButton, {
            onClick: function onClick() {
              return dismiss();
            }
          }, _this.props.dismissButtonText), React.createElement(ConfirmButtonComponent, {
            onClick: function onClick() {
              return _this.props.onConfirm();
            }
          }, _this.props.confirmButtonText))));
        }
      }, function (open, dismiss) {
        return _this.props.children && _this.props.children(open, dismiss);
      });
    }
  }]);

  return ConfirmationDialog;
}(React.Component);

export { ConfirmationDialog as default };